// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function TaxReportingCarousel(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = React.useState(function () {
    return 0;
  });
  const setIdx = match[1];
  const idx = match[0];
  const match$1 = React.useState(function () {
    
  });
  const setInt = match$1[1];
  const interval = match$1[0];
  const match$2 = React.useState(function () {
    
  });
  const setRemove = match$2[1];
  const remove = match$2[0];
  const imgRef = React.useRef(null);
  const images_0 = {
    src: deviceType === "mobile" ? "/static/images/910.png" : "/static/images/910-desktop.png"
  };
  const images_1 = {
    hd: {
      src: "/static/images/avr.png"
    },
    tl: /* [] */ 0
  };
  const images = {
    hd: images_0,
    tl: images_1
  };
  const clean = function (param) {
    if (interval !== undefined) {
      clearInterval(Caml_option.valFromOption(interval));
    }
    if (remove !== undefined) {
      clearTimeout(Caml_option.valFromOption(remove));
      return;
    }
    
  };
  React.useEffect((function () {
    const cardElement = imgRef.current;
    Belt__Belt_Option.map((cardElement == null) ? undefined : Caml_option.some(cardElement), (function (el) {
      el.classList.remove("filter-blur-10");
      const remove = setTimeout((function (param) {
        el.classList.add("filter-blur-10");
      }), 4800);
      Curry._1(setRemove, (function (param) {
        return Caml_option.some(remove);
      }));
      return function (param) {
        clearTimeout(remove);
      };
    }));
    const intrvl = setInterval((function (param) {
      const nextIdx = idx + 1 | 0;
      if (nextIdx < Stdlib__List.length(images)) {
        return Curry._1(setIdx, (function (param) {
          return nextIdx;
        }));
      } else {
        return Curry._1(setIdx, (function (param) {
          return 0;
        }));
      }
    }), 5000);
    Curry._1(setInt, (function (param) {
      return Caml_option.some(intrvl);
    }));
    return (function (param) {
      clearInterval(intrvl);
    });
  }), [idx]);
  const image = Stdlib__List.nth(images, idx);
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsx("img", {
        ref: imgRef,
        className: "transition-filter duration-150 ease-in lg:flex lg:m-auto mt-10 lg:mt-20 w-252",
        alt: "transition",
        src: StaticAsset.src(image.src)
      }),
      JsxRuntime.jsx("div", {
        children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, param) {
          const Key = "carousel_step_" + String(i);
          return JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              className: i === idx ? "opacity-100" : "opacity-24",
              src: StaticAsset.src("/static/icons/step.svg")
            }),
            className: "ml-2 first:ml-0 cursor-pointer py-4",
            onClick: (function (param) {
              clean(undefined);
              Curry._1(setIdx, (function (param) {
                return i;
              }));
            })
          }, Key);
        }), images)),
        className: "flex justify-center mt-15 lg:mt-10"
      })
    ]
  });
}

const make = TaxReportingCarousel;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
